/**
 * Componente de Estado Vazio
 * Exibe mensagem quando não há dados para mostrar
 * 
 * @author Equipe GestaoeCRM
 * @date 19/12/2025
 */

import { LucideIcon } from 'lucide-react';
import { cn } from '@/utils/cn';

interface EmptyStateProps {
  icon?: LucideIcon;
  title: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

export default function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  className,
  size = 'md',
}: EmptyStateProps) {
  const sizeClasses = {
    sm: {
      icon: 'h-8 w-8',
      title: 'text-base',
      description: 'text-sm',
    },
    md: {
      icon: 'h-12 w-12',
      title: 'text-lg',
      description: 'text-sm',
    },
    lg: {
      icon: 'h-16 w-16',
      title: 'text-xl',
      description: 'text-base',
    },
  };

  const currentSize = sizeClasses[size];

  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center p-8 text-center',
        className
      )}
    >
      {Icon && (
        <Icon
          className={cn(
            'text-text-muted mb-4',
            currentSize.icon
          )}
        />
      )}

      <h3
        className={cn(
          'font-medium text-text-primary mb-2',
          currentSize.title
        )}
      >
        {title}
      </h3>

      {description && (
        <p
          className={cn(
            'text-text-secondary max-w-md',
            currentSize.description
          )}
        >
          {description}
        </p>
      )}

      {action && (
        <div className="mt-6">
          {action}
        </div>
      )}
    </div>
  );
}

